import React, { Component } from 'react';
import $ from 'jquery';
import {ApiClient} from '../libs/apiClient';
import { CURRENCY } from '../libs/utils/Const';

let apiClient = ApiClient.getInstance();
const formatNumber = {
    separador: ',', // separador para los miles
    sepDecimal: '.', // separador para los decimales
    formatear: function (num) {
        num += '';
        let splitStr = num.split('.');
        let splitLeft = splitStr[0];
        let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        let regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },
    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0;
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    },
};

class AsientoContableModal extends Component{

    constructor(props) {
        super(props);
    }

    closeConfirm = async () => {
        $('#AsientoContableModal').modal('hide');  
    }

    render() {
        const {Asiento,AsientoContable} = this.props;
        
        let asiento = AsientoContable ? AsientoContable : [];
        let asientos = Asiento ? Asiento : [];
        return (
            <div className="modal fade bd-example-modal-lg scroll bgtransparent" id="AsientoContableModal" style={{zIndex: 91}}
                 role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div className="modal-dialog modal-xl " role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white"
                            style={{backgroundColor: '#343a40', borderRadius: '0'}}>
                            <h4 className="modal-title" id="modal-basic-title ">
                                Asiento Contable
                            </h4>
                            <button type="button" className="close" onClick={this.closeConfirm} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="container">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div>
                                            <table className="table response" style={{marginBottom: 0}}>
                                                {/*HEADER*/}
                                                <div className="row" style={{paddingRight: 0}}>
                                                    {/*Primer columna*/}
                                                    <div className="col-sm col">
                                                        {/*SERIE*/}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Serie</span>
                                                            </div>
                                                                <input type="text" className="form-control" id="txtPartner"
                                                                    value={asientos.NameSerie ? asientos.NameSerie : ''}/>
                                                        </div>
                                                        {/*NÚMERO*/}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Número</span>
                                                            </div>
                                                            <input
                                                                        type="text"
                                                                        className="form-control "
                                                                        id="txtName"
                                                                        disabled="true"
                                                                        value={asientos.Number ? asientos.Number : ''}/>
                                                        </div>
                                                        
                                                        {/*NÚM ORIGEN*/}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Núm. Origen</span>
                                                            </div>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="txtLocalCurrency"
                                                                    disabled={true}
                                                                    value={asientos.Ref1 ? asientos.Ref1 : ''}
                                                                />
                                                        </div>
                                                        {/*REFERENCIA */}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Referencia 1</span>
                                                            </div>
                                                            <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="txtLocalCurrency"
                                                                            disabled={true}
                                                                            value={asientos.Ref1 ? asientos.Ref1 : ''}
                                                                        />

                                                        </div>
                                                    </div>
                                                    
                                                    {/*Segunda columna*/}
                                                    <div className="col-sm col">

                                                        {/*Fecha de contabilización:*/}
                                                            <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1"> F. Contabilización</span>
                                                            </div>
                                                            <input
                                                                    id="txtPostingDate"
                                                                    style={{
                                                                        important: true,
                                                                        backgroundColor: 'transparent',
                                                                        borderColor: '#ced4da',
                                                                        color: '#000',
                                                                    }}
                                                                    className="form-control"
                                                                    type='text'
                                                                    placeholder="Fecha min"
                                                                    autoComplete="off"
                                                                    value={asientos.RefDate ? asientos.RefDate : ''}
                                                                />
                                            
                                                            </div>
                                                        {/*Fecha de entrega:*/}
                                                            <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">F. Vencimiento</span>
                                                            </div>
                                                            <input
                                                                    id="txtDeliverDate"
                                                                    style={{
                                                                        important: true,
                                                                        backgroundColor: 'transparent',
                                                                        borderColor: '#ced4da',
                                                                        color: '#000',
                                                                    }}
                                                                    className="form-control"
                                                                    type='text'
                                                                    placeholder="Fecha min"
                                                                    autoComplete="off"
                                                                    value={asientos.DueDate ? asientos.DueDate : ''}
                                                                />
                                            
                                                            </div>
                                                        {/*>Fecha de documento:*/}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">F. Documento</span>
                                                            </div>
                                                            <input
                                                                        style={{
                                                                            important: true,
                                                                            backgroundColor: 'transparent',
                                                                            borderColor: '#ced4da',
                                                                            color: '#000',
                                                                        }}
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="txtStatus"
                                                                        autoComplete="off"
                                                                        disabled="true"
                                                                        value={asientos.TaxDate ? asientos.TaxDate : ''}
                                                                    />
                                                        </div>
                                                                        
                                                    </div>
                                                </div>
                                                {/*BODY*/}
                                                <div style={{marginBottom: 30}}>
         
                                                    <div style={{height: 400, overflow: 'auto'}}>
                                                        <table
                                                            // id="dataTableDocuments"
                                                            className="display"
                                                            style={{width: '100%', marginBottom: 40, marginRight: -3000}}>
                                                            <thead className="table-header-yellow">
                                                            <tr style={{textAlign: "center"}}>
                                                                <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                    Código SN
                                                                </td>
                                                                <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                    Nombre SN
                                                                </td>
                                                                <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                    Cuenta Asociada
                                                                </td>
                                                                <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                    Débito
                                                                </td>
                                                                <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                    Crédito
                                                                </td>
                                                                <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                    Débito (MS)
                                                                </td>
                                                                <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                    Crédito (MS)
                                                                </td>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                                {/* Filas de tabla  */}
                                                                {asiento.map((item, index) => {
                                                                    return (     
                                                                        <tr style={{
                                                                            maxHeight: 10,
                                                                            paddingTop: 8,
                                                                            paddingBottom: 8,
                                                                            color: item.stock ? 'black' : 'red',
                                                                            backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : 'transparent'}}>

                                                                            {/*CODIGO SN*/}
                                                                                <td className="sticky-column"
                                                                                    style={{backgroundColor:'#FFF'}}>
                                                                                    {item.AcctCode}
                                                                                </td>
                                                                            {/*NOMBRE SN*/}
                                                                                <td
                                                                                    className="overflow-visible"
                                                                                    style={{textAlign: 'center', maxWidth: 800}}>
                                                                                    {item.AcctName}
                                                                                </td>
                                                                            {/*CUENTA ASOCIADA*/}
                                                                                <td
                                                                                    className="overflow-visible"
                                                                                    style={{textAlign: 'center', maxWidth: 800}}>
                                                                                    {item.FormatCode}
                                                                                </td>
                                                                            {/*DEBITO*/}
                                                                                <td
                                                                                    className="overflow-visible"
                                                                                    style={{textAlign: 'center', maxWidth: 800}}>
                                                                                    {item.Debit !== 0 ? CURRENCY + formatNumber.new(item.Debit) + " " + item.DocCur : ''}
                                                                                </td>
                                                                            {/*CREDITO*/}
                                                                                <td
                                                                                    className="overflow-visible"
                                                                                    style={{textAlign: 'center', maxWidth: 800}}>
                                                                                    {item.Credit !== 0 ? CURRENCY+ formatNumber.new(item.Credit) + " " + item.DocCur : ''}
                                                                                </td>
                                                                            {/*DEBITO MS*/}
                                                                                <td
                                                                                    className="overflow-visible"
                                                                                    style={{textAlign: 'center', maxWidth: 800}}>
                                                                                    {item.SYSDeb !== 0 ?  formatNumber.new(item.SYSDeb) + " USD" : ''}
                                                                                </td>
                                                                            {/*CREDITO MS*/}
                                                                                <td
                                                                                    className="overflow-visible"
                                                                                    style={{textAlign: 'center', maxWidth: 800}}>
                                                                                    {item.SYSCred !== 0 ?  formatNumber.new(item.SYSCred) + " USD" : ''}
                                                                                </td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCorrect text-black" onClick={this.closeConfirm}>Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        );  
    }
}
export default AsientoContableModal;